(function() {
    /**
     * Prototype extend
     */

    if (!Array.prototype.indexOf) Array.prototype.indexOf = function(el) {
        for (var i = 0; i < this.length; i ++) {
            if (this[i] == el) return i;
        }
        return -1;
    }

    if (!Object.keys) Object.keys = function(obj) {
        var keys = [];
        for (var k in obj) keys.push(k);
        return keys;
    }

    if (!window.console) {
        var Console = function() {};
        Console.prototype = {
            log: function(v) {},
            info: function(v) {},
            warn: function(v) {},
            error: function(v) {}
        };
        window.console = new Console();
    }

    Number.prototype.toPrice = function(params) {
        params = params || {};
        var price = this.toFixed(2);

        var integer = Math.floor(price);
        var fraction = (price - integer)*100;

        var html = '';
        if (params.space) {
            var num = integer;
            while (typeof num !== 'undefined') {
                var sub = num % 1000;
                if (num >= 1000 && sub < 100) {
                    if (sub < 10) {
                        sub = '00'+sub.toString();
                    } else {
                        sub = '0'+sub.toString();
                    }
                }
                html = sub + ((html !== '') ? ' '+html : '');
                num = (num >= 1000) ? (num - sub)/1000 : undefined;
            }
        } else {
            html = integer.toString();
        }

        if (fraction === 0) {
            fraction = '.';
        } else if (fraction < 10) {
            fraction = '0'+fraction;
        }

        html += '-'+fraction;

        return html;
    };

    Number.prototype.wordForm = function(a, b, c) {
        if (/^(\d*)(\.\d+)$/.test(this)) return b;
        var d100 = this % 100, d10 = this % 10;
        if (d100 < 5 || d100 > 20) {
            if (d10 == 1) {
                return a;
            } else  if (d10 > 0 && d10 < 5) {
                return b;
            }
        }
        return c;
    }

    String.prototype.ucFirst = function() {
        return this && this.charAt(0).toUpperCase() + this.slice(1);
    }
    String.prototype.lcFirst = function() {
        return this && this.charAt(0).toLowerCase() + this.slice(1);
    }
})();

(function() {
    /**
     * Merge the contents of two or more objects together into the first object
     * (based on jQuery extend function)
     * @param {Boolean} [recursive] - recursive flag
     * @param {Object} target - target object
     * @param {Object*} [objectN] - object to merge in
     * @return {Object} target object
     */
    Object.extend = function() {
        var n = 1,
            recursive = false,
            target = arguments[0],
            obj,
            name, src, val;

        // check for recursive flag in first argument
        if (typeof target === 'boolean') {
            recursive = target;
            target = arguments[1];
            n = 2;
        }

        if ((typeof target !== 'object') && (typeof target !== 'function')) {
            target = {};
        }

        for ( ; n < arguments.length; n++) {
            if ((obj = arguments[n]) != null) {
                for (name in obj) {
                    src = target[name];
                    val = obj[name];
                    // convert Number and String object to primitives
                    if (typeof val === 'object') {
                        if (val instanceof Number) {
                            val = Number(val);
                        } else if (val instanceof String) {
                            val = String(val);
                        }
                    }
                    // Try to recursive merge if copy is object and nor array or function
                    if ((recursive) && (typeof val === 'object') && (val) && (!(val instanceof Function)) && (!(val instanceof Array))) {
                        target[name] = Object.extend(recursive, src, val);
                    } else if (val !== undefined) {
                        target[name] = val;
                    }
                }
            }
        }
        return target;
    };
    /**
     * Merging content two or more objects non-recursive to new object
     * @param {Object*} two or more objects
     * @return {Object} the result
     */
    Object.merge = function() {
        var args = [{}];
        for (var i = 0; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return Object.extend.apply(this, args);
    };


    function __p() {}
    /**
     * Create prototype chain for object
     * @param {Object} child - child object
     * @param {Object} parent - parent object
     * @return {Object} child object
     */
    Object.inherit = function(child, parent) {
        __p.prototype = parent.prototype || {};
        child.prototype = new __p();
        child.prototype.constructor = child;
        child.SUPER = parent.prototype;
        return child;
    };

    // Aliases to Function() object

    /**
     * Add prototype chain to object
     * @param {Object} parent - parent object
     * @return {Object}
     */
    Function.prototype.inherit = function(parent) {
        return Object.inherit(this, parent);
    };

    /**
     * Extend object prototype
     * @param {object} proto
     * @return {Function}
     */
    Function.prototype.proto = function(proto) {
        Object.extend(this.prototype, proto);
        return this;
    };
})();

var Cookies = (function() {
    var EXPIRES_REGEXP = /\+(\d+)(i|h|d|m|y)/;

    return {
        /**
         * Устанавливает значение cookie
         * @param {String} name
         * @param {String} value
         * @param {String} expires возможно использовать инкрементные значения (+1d, +2m ...)
         * @param {String} path
         * @param {String} domain
         * @param {Boolean} secure
         */
        set : function(name, value, expires, path, domain, secure) {
            if (expires) {
                expires = expires.toString().match(EXPIRES_REGEXP);
            }
            if (expires) {
                var date = new Date();
                var c = parseInt(expires[1]);
                var s = expires[2];
                switch (s) {
                    case 'y':
                        date.setFullYear(date.getFullYear() + c);
                        break;
                    case 'm':
                        date.setMonth(date.getMonth() + c);
                        break;
                    case 'd':
                        date.setDate(date.getDate() + c);
                        break;
                    case 'h':
                        date.setHours(date.getHours() + c);
                        break;
                    case 'i':
                        date.setMinutes(date.getMinutes() + c);
                        break;
                }
                expires = date.toUTCString();
            }
            document.cookie = name + "=" + escape(value) +
                ((expires) ? "; expires=" + expires : "") +
                ((path) ? "; path=" + path : "") +
                ((domain) ? "; domain=" + domain : "") +
                ((secure) ? "; secure" : "");
        },
        /**
         * Получает значение cookie
         * @param {String} name
         */
        get : function(name) {
            var cookie = " " + document.cookie;
            var search = " " + name + "=";
            var setStr = null;
            var offset = 0;
            var end = 0;
            if (cookie.length > 0) {
                offset = cookie.indexOf(search);
                if (offset != -1) {
                    offset += search.length;
                    end = cookie.indexOf(";", offset);
                    if (end == -1)
                        end = cookie.length;
                    setStr = unescape(cookie.substring(offset, end));
                }
            }
            return setStr;
        }
    };
})();

/**
 * Класс для обработки специфических функций браузера
 */
var Browser = (function() {
    var userAgent = navigator.userAgent.toLowerCase();
    var _ie = /msie/.test(userAgent) && !/opera/.test(userAgent);
    var _old_ie = /MSIE (5\.5|6).+Win/.test(userAgent);
    var _ie7 = /MSIE (7).+Win/.test(userAgent);
    var _ie8 = /MSIE (8).+Win/.test(userAgent);
    var _opera = /opera/.test(userAgent);
    var _webkit = /webkit/.test(userAgent);
    var _mobile = /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm|mobi|tablet/i.test(userAgent);

    return {
        isOpera: _opera,
        isMSIE: _ie,
        isWebKit: _webkit,
        isIE6: _old_ie,
        isIE7: _ie7,
        isIE8: _ie8,
        isMobile: _mobile,
        supportsAttribute: function(attr, el) {
            el = el || 'div';
            if (typeof el === 'string') {
                el = document.createElement(el);
            }
            return attr in el;
        },
        supportsStyle: function(prop, el) {
            el = el || 'div';
            if (typeof el === 'string') {
                el = document.createElement(el);
            }
            return el.style[prop] !== undefined;
        },
        /**
         * Определяет область с основной прокруткой
         * (в браузерах на WebKit она волшебным образом отличается
         */
        getScrollBody: function() {
            return document.documentElement;
        },
        getMousePosition: function(e) {
            e = e || window.event;
            var mouseLeft = e.pageX || e.clientX + (document.documentElement && document.documentElement.scrollLeft || document.body && document.body.scrollLeft || 0) - (document.documentElement.clientLeft || 0);
            var mouseTop = e.pageY || e.clientY + (document.documentElement && document.documentElement.scrollTop || document.body && document.body.scrollTop || 0) - (document.documentElement.clientTop || 0);
            return {
                left: mouseLeft,
                top: mouseTop
            };
        }
    };
})();

$.fn.extend({
    serializeObject: function(options) {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function() {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value);
            } else {
                o[this.name] = this.value;
            }
        });
        return o;
    }
});
